import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '100vw'
    }
  },

  newNote: {
    margin: '0 auto 1rem auto'
  },

  noteRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '0.0625rem solid #F1F1F1',
    minHeight: 48,
    padding: '0px 16px',
    cursor: 'pointer',

    '& svg': {
      flexShrink: 0
    }
  },

  noteTitle: {
    width: '100%',

    cursor: 'inherit',
    fontSize: theme.size.base
  }
}))

export default useStyles
